import { booleanType, ensure, stringType, TType } from "types";

import { configDatabaseRecordType, IDatabaseRecord } from "@/core/api";
import { dateTimeType, TDateTime } from "@/core/dates";
import { ILocation } from "@/data/locations";
import { TUserRole } from "@/data/session";

export enum TInvitationStatus {
  PENDING = "PENDING",
  ACCEPTED = "ACCEPTED",
}

export interface IInvitation extends IDatabaseRecord {
  alreadyExist: boolean;
  email: string;
  expirationDate: TDateTime;
  firstName: string;
  lastName: string;
  status: TInvitationStatus;
  type: TUserRole;
}

export const configInvitationType: TType<IInvitation> = {
  ...configDatabaseRecordType,
  alreadyExist: booleanType(null),
  email: stringType(""),
  expirationDate: dateTimeType(),
  firstName: stringType(""),
  lastName: stringType(""),
  status: stringType(""),
  type: stringType(""),
};

export const invitationType = ensure(configInvitationType);

export interface IInvitationDto extends Pick<IInvitation, "firstName" | "lastName" | "email"> {
  location?: ILocation | null;
  skipInvitation?: boolean;
}

export interface IRegisterInvitationDto extends Pick<IInvitation, "firstName" | "lastName" | "email"> {
  token: string;
  password: string;
  confirmPassword: string;
}
